import { features } from '@/mocks/content';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            核心功能
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            为什么选择抖阴pro？
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            我们精心打磨每一个功能细节，只为给您带来最好的短视频观看与创作体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}